import { client, loadToken } from 'services/api/client';
export { loadToken };

export async function getLiveSnapshot(stopId) {
    const { data } = await client.get(`/stopmonitor/live/${stopId}`);
    return data;
}

export async function getTripHistory(stopId) {
    const { data } = await client.get(`/stopmonitor/history?stopId=${stopId}`);
    return data;
}

export async function postArrived(matchKey, stopId) {
    const { data } = await client.post(`/stopmonitor/transitReport/arrived`, { matchKey, stopId });
    return data;
}

export async function postAnomaly(matchKey, stopId) {
    const { data } = await client.post(`/stopmonitor/transitReport/anomaly`, { matchKey, stopId });
    return data;
}

export async function postGhostBus(payload) {
    const { data } = await client.post(`/stopmonitor/ghostBus`, payload);
    return data;
}

export async function getLiveTripDetail(matchKey, stopId) {
    const { data } = await client.get(`/stopmonitor/transitReport/live-detail?matchKey=${matchKey}&stopId=${stopId}`);
    return data;
}

const all = {
    loadToken,
    getLiveSnapshot,
    getTripHistory,
    postArrived,
    postAnomaly,
    postGhostBus,
    getLiveTripDetail
};

export default all;